// extracted by mini-css-extract-plugin
export default {"container":"Favorite_container__WSXtV","column":"Favorite_column__zF0Dg","cards":"Favorite_cards__ZSR2Q"};